(function () {
    'use strict';

    function siteConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/siteConfiguration.html',
            link: function (scope) {
            }
        };
    }

    siteConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('siteConfiguration', siteConfiguration);
})();

